
import { getElectronAPI } from "@/plugins/desktop";

const STATUS_MAP = {
  pendente_xml:                 { label: "Pendente XML",        cls: "nd-status--warning", icon: "fas fa-clock" },
  xml_gerado:                   { label: "XML gerado",          cls: "nd-status--info",    icon: "fas fa-file-code" },
  xml_assinado:                 { label: "XML assinado",        cls: "nd-status--info",    icon: "fas fa-signature" },
  pendente_transmissao_backend: { label: "Pendente transmissão",cls: "nd-status--warning", icon: "fas fa-paper-plane" },
  pendente_transmissao:         { label: "Pendente transmissão",cls: "nd-status--warning", icon: "fas fa-paper-plane" },
  autorizada:                   { label: "Autorizada",          cls: "nd-status--success", icon: "fas fa-check-circle" },
  rejeitada:                    { label: "Rejeitada",           cls: "nd-status--danger",  icon: "fas fa-ban" },
  erro_transmissao:             { label: "Erro transmissão",    cls: "nd-status--danger",  icon: "fas fa-exclamation-circle" },
  erro:                         { label: "Erro",                cls: "nd-status--danger",  icon: "fas fa-exclamation-circle" },
  cancelada:                    { label: "Cancelada",           cls: "nd-status--secondary",icon: "fas fa-ban" },
};

export default {
  name: "NfceDetalheModal",

  filters: {
    dataHora(dt) {
      if (!dt) return "—";
      try {
        return new Date(dt).toLocaleString("pt-BR", {
          day: "2-digit", month: "2-digit", year: "numeric",
          hour: "2-digit", minute: "2-digit",
        });
      } catch { return dt; }
    },
    brl(v) {
      return Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
  },

  props: {
    nfce: { type: Object, required: true },
  },

  emits: ["fechar"],

  data() {
    return {
      abaAtiva:        "resumo",
      itens:           [],
      pagamentos:      [],
      carregandoItens: false,
      copiado:         null,
      nfceFull:        null,
    };
  },

  computed: {
    nfceDetalhe() {
      return this.nfceFull || this.nfce;
    },
    statusLabel() {
      return STATUS_MAP[this.nfceDetalhe.status_fiscal]?.label || this.nfceDetalhe.status_fiscal || "—";
    },
    statusClass() {
      return STATUS_MAP[this.nfceDetalhe.status_fiscal]?.cls || "nd-status--secondary";
    },
    statusIcon() {
      return STATUS_MAP[this.nfceDetalhe.status_fiscal]?.icon || "fas fa-question-circle";
    },
    tipoEmissaoLabel() {
      return this._extrairTpEmis(this.nfceDetalhe) === 9 ? "Contingência" : "Normal";
    },
  },

  async mounted() {
    await this._carregar();
  },

  methods: {
    async _carregar() {
      this.carregandoItens = true;
      try {
        const api  = getElectronAPI();
        const full = await api.nfce.getByUuid(this.nfce.uuid_venda_terminal);
        if (full) {
          this.nfceFull   = full;
          this.itens      = full.itens      || [];
          this.pagamentos = full.pagamentos || [];
        } else {
          this.itens = (await api.nfce.getItens(this.nfce.uuid_venda_terminal)) || [];
        }
      } catch (e) {
        console.warn("[NfceDetalheModal] Erro ao carregar:", e.message);
      } finally {
        this.carregandoItens = false;
      }
    },

    fmtChave(v) {
      if (!v || v.length !== 44) return v || "—";
      return v.match(/.{1,4}/g).join(" ");
    },

    formatQtd(q) {
      const n = Number(q || 0);
      return n % 1 === 0 ? String(n) : n.toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3 });
    },

    _parsePayload(item) {
      try { return item.payload_json ? JSON.parse(item.payload_json) : {}; } catch { return {}; }
    },

    itemExtras(item) {
      const extras = [];
      const p = this._parsePayload(item);

      const lote = item.lote || p.lote || p.numero_lote || p.lote_codigo;
      if (lote) extras.push(`Lote: ${lote}`);

      const combinacao = p.combinacao || p.combinacao_descricao || p.combinations;
      if (combinacao) {
        if (Array.isArray(combinacao)) {
          combinacao.forEach((c) => {
            const desc = c?.descricao || c?.nome || c?.label;
            if (desc) extras.push(`Combinação: ${desc}`);
          });
        } else if (typeof combinacao === "string") {
          extras.push(`Combinação: ${combinacao}`);
        }
      }

      const pesado = p.produto_pesado || p.pesado || item.pesado;
      const codigoBalanca = p.codigo_balanca || p.cod_balanca || item.codigo_balanca;
      if (pesado || codigoBalanca) {
        extras.push(`Pesado${codigoBalanca ? ` (cód.: ${codigoBalanca})` : ""}`);
      }

      return extras;
    },

    _extrairTpEmis(nfce) {
      if (!nfce) return 1;
      if (nfce.tipo_emissao != null && String(nfce.tipo_emissao) !== "") return Number(nfce.tipo_emissao);
      if (nfce.tpEmis      != null && String(nfce.tpEmis) !== "")       return Number(nfce.tpEmis);
      try {
        if (nfce.dados_json) {
          const d = typeof nfce.dados_json === "string" ? JSON.parse(nfce.dados_json) : nfce.dados_json;
          const fromJson = d?.ide?.tpEmis ?? d?.tpEmis;
          if (fromJson != null) return Number(fromJson);
        }
      } catch { /* ignora */ }
      const xml = nfce.xml_autorizado || nfce.xml_assinado || nfce.xml;
      if (xml && typeof xml === "string") {
        const m = xml.match(/<tpEmis>\s*(\d)\s*<\/tpEmis>/i);
        if (m) return Number(m[1]);
      }
      return 1;
    },

    copiar(texto, chave = "chave") {
      if (!texto) return;
      navigator.clipboard.writeText(texto).then(() => {
        this.copiado = chave;
        setTimeout(() => { this.copiado = null; }, 2500);
      }).catch(() => {});
    },
  },
};
